import { useQuery } from '@hooks/reactQuery';

import { getResponsible } from '@api/assets';

import { extractQueryParams } from '@utils/common';
import { optionsFormatted } from '@utils/formatter';

import { TResponsible } from '@interfaces/components/form';

import { refetchOptions } from '@constants/common';
import { RESPONSIBLE } from '@constants/queryKeys';

export const useQueryResponsiblePersons = () => {
	const {
		data: responsibleOptions,
		isInitialLoading,
	} = useQuery({
		queryKey: [RESPONSIBLE],
		queryFn: extractQueryParams(getResponsible),
		select: (responsibleOptions: Array<TResponsible>) => optionsFormatted(responsibleOptions),
		...refetchOptions,
	});

	return {
		responsibleOptions,
		isLoadingResponsiblePersons: isInitialLoading,
	};
};
